module.exports = require("./sd-Arab.d.ts");